"use client";

import { ReactNode, useEffect, useState } from "react";
import { getIsUserFromUs } from "utils/local-storage";
type TPriceWithUsdProps = {
  price: ReactNode;
  className?: string;
  currency?: string;
  currencyClassName?: string;
  priceClassName?: string;
  priceWrapperClassName?: string;
  isStrikePrice?: boolean;
  strikeLineClassName?: string;
  withTrailingSpace?: boolean;
  forceDisplayUSD?: boolean;
};
const PriceWithUsd = ({
  price,
  className,
  currency = "usd",
  currencyClassName = "text-lg font-bold",
  priceClassName,
  priceWrapperClassName,
  isStrikePrice = false,
  strikeLineClassName,
  withTrailingSpace = false,
  forceDisplayUSD = true // Default: always show USD for all users. When set to false, USD is shown only for non-US users; US users will hide it.
}: TPriceWithUsdProps) => {
  const [shouldShowUsd, setShouldShowUsd] = useState(false);
  useEffect(() => {
    setShouldShowUsd(getIsUserFromUs() === "false");
  }, []);
  return <>
      <span className={`inline-flex items-baseline gap-1 ${className}`}>
        <span className={`
            ${isStrikePrice ? "relative inline-block" : ""}
            ${priceWrapperClassName}
          `}>
          <span className={priceClassName}>{price}</span>
          {isStrikePrice && <span aria-hidden='true' className={`
                absolute -top-[17px] right-0 h-full w-full translate-y-[50%] rotate-[162deg] border-t-[1px] border-[#000]
                ${strikeLineClassName}
              `} />}
        </span>

        {/** behavior: Show USD by default for all users. * If forceDisplayUSD is false, currency is shown only when the user is not in the US; US users will hide it. */}
        {(forceDisplayUSD || shouldShowUsd) && <span className={`[font-variant:small-caps] ${currencyClassName}`}>
            {currency}
          </span>}
      </span>
      {withTrailingSpace && "\u00A0"}
    </>;
};
export default PriceWithUsd;